import * as React from 'react';
import * as styles from './styles.css';

export const OffersMarks = ({ children }: React.PropsWithChildren<{}>) => {
  return <div className={styles['marks']}>{children}</div>;
};

OffersMarks.displayName = 'OffersMarks';
